import { render, staticRenderFns } from "./TermsBody.vue?vue&type=template&id=ea5496f4&scoped=true&"
import script from "./TermsBody.vue?vue&type=script&lang=js&"
export * from "./TermsBody.vue?vue&type=script&lang=js&"
import style0 from "./TermsBody.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TermsBody.vue?vue&type=style&index=1&id=ea5496f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5496f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea5496f4')) {
      api.createRecord('ea5496f4', component.options)
    } else {
      api.reload('ea5496f4', component.options)
    }
    module.hot.accept("./TermsBody.vue?vue&type=template&id=ea5496f4&scoped=true&", function () {
      api.rerender('ea5496f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Declare/Terms/TermsBody.vue"
export default component.exports